import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-85d58ba0")

_pushScopeId("data-v-85d58ba0")
const _hoisted_1 = { class: "vue-flex-row inquiry-item-header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("質問 ")
const _hoisted_3 = { class: "page-item-list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_normal_edit_box = _resolveComponent("normal-edit-box")
  const _component_icon_button_middle = _resolveComponent("icon-button-middle")
  const _component_vue_head_button_frame = _resolveComponent("vue-head-button-frame")
  const _component_list_title = _resolveComponent("list-title")
  const _component_list_row = _resolveComponent("list-row")
  const _component_inquiry_option_modal = _resolveComponent("inquiry-option-modal")
  const _component_vue_sub_content = _resolveComponent("vue-sub-content")

  return (_openBlock(), _createBlock(_component_vue_sub_content, null, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_normal_edit_box, {
          class: "inquiry-page-title",
          placeholder: "質問のタイトル",
          readonly: !_ctx.dataWrite,
          modelValue: _ctx.pageTitles[_ctx.selectedInquiryItemIndex][_ctx.pageIndex],
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pageTitles[_ctx.selectedInquiryItemIndex][_ctx.pageIndex] = $event))
        }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["readonly", "modelValue"]),
        _createVNode(_component_vue_head_button_frame, null, {
          default: _withId(() => [
            _createVNode(_component_icon_button_middle, {
              class: "group-button",
              icon: "plus",
              state: "normal",
              disabled: !_ctx.dataWrite,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addInquiryPageItem(_ctx.pageIndex)))
            }, null, 8, ["disabled"]),
            _createVNode(_component_icon_button_middle, {
              class: "group-button",
              icon: "arrow-up",
              state: "warning",
              disabled: _ctx.pageIndex === 0 || !_ctx.dataWrite,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.upInquiryPage(_ctx.pageIndex)))
            }, null, 8, ["disabled"]),
            _createVNode(_component_icon_button_middle, {
              class: "group-button",
              icon: "arrow-down",
              state: "warning",
              disabled: _ctx.pageIndex === _ctx.pageTitles[_ctx.selectedInquiryItemIndex].length - 1 || !_ctx.dataWrite,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downInquiryPage(_ctx.pageIndex)))
            }, null, 8, ["disabled"]),
            _createVNode(_component_icon_button_middle, {
              class: "group-button",
              icon: "times",
              state: "delete",
              disabled: !_ctx.dataWrite,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteInquiryPage(_ctx.pageIndex)))
            }, null, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_list_title, { titles: _ctx.inquiryPageItemTitles }, null, 8, ["titles"]),
        _createVNode(_TransitionGroup, null, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.inquiryPageItemRows[_ctx.pageIndex], (row, k) => {
              return (_openBlock(), _createBlock(_component_list_row, {
                key: row.id,
                rowId: row.id,
                columns: row.columns,
                onClick: ($event: any) => (_ctx.onClick(k, $event)),
                onValueType: ($event: any) => (_ctx.onSelectValueType(k, $event)),
                onPageItemTitle: ($event: any) => (_ctx.onPageItemTitle(k, $event)),
                onRequired: ($event: any) => (_ctx.onRequired(k)),
                onOption: ($event: any) => (_ctx.onClick(k, { emitType: 'option' }))
              }, null, 8, ["rowId", "columns", "onClick", "onValueType", "onPageItemTitle", "onRequired", "onOption"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_inquiry_option_modal, { ref: "optionRef" }, null, 512)
    ]),
    _: 1
  }))
})